// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { fermentationProcedureId } from './FermentationProcedure';
import { equipmentModelId } from './EquipmentModel';
import { cleaningRecordId } from './CleaningRecord';
import { z } from 'zod';
export const fermentationGroupId = (z.number());
export const fermentationGroup = z.object({
    id: fermentationGroupId,
    label: z.string().nullable(),
    responsible_operator_id: operatorId,
    objectives: z.string().nullable(),
    conclusions: z.string().nullable(),
    description: z.string().nullable(),
    name: z.string(),
    discussion: z.string().nullable(),
    protocol_template_google_drive_identifier: z.string().nullable(),
    fermentation_count: z.number().nullable(),
    locked: z.boolean(),
    is_data_completed: z.boolean(),
    procedure_id: fermentationProcedureId.nullable(),
    equipment_model_id: equipmentModelId.nullable(),
    pre_cleaning_record_id: cleaningRecordId.nullable(),
    post_cleaning_record_id: cleaningRecordId.nullable(),
});
export const fermentationGroupInitializer = z.object({
    id: fermentationGroupId.optional(),
    label: z.string().optional().nullable(),
    responsible_operator_id: operatorId,
    objectives: z.string().optional().nullable(),
    conclusions: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    name: z.string(),
    discussion: z.string().optional().nullable(),
    protocol_template_google_drive_identifier: z.string().optional().nullable(),
    fermentation_count: z.number().optional().nullable(),
    locked: z.boolean().optional(),
    is_data_completed: z.boolean().optional(),
    procedure_id: fermentationProcedureId.optional().nullable(),
    equipment_model_id: equipmentModelId.optional().nullable(),
    pre_cleaning_record_id: cleaningRecordId.optional().nullable(),
    post_cleaning_record_id: cleaningRecordId.optional().nullable(),
});
export const fermentationGroupMutator = z.object({
    id: fermentationGroupId.optional(),
    label: z.string().optional().nullable(),
    responsible_operator_id: operatorId.optional(),
    objectives: z.string().optional().nullable(),
    conclusions: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    name: z.string().optional(),
    discussion: z.string().optional().nullable(),
    protocol_template_google_drive_identifier: z.string().optional().nullable(),
    fermentation_count: z.number().optional().nullable(),
    locked: z.boolean().optional(),
    is_data_completed: z.boolean().optional(),
    procedure_id: fermentationProcedureId.optional().nullable(),
    equipment_model_id: equipmentModelId.optional().nullable(),
    pre_cleaning_record_id: cleaningRecordId.optional().nullable(),
    post_cleaning_record_id: cleaningRecordId.optional().nullable(),
});
//# sourceMappingURL=FermentationGroup.js.map